const translations = {
    createdAt: 'Created At',
    email: 'Email',
    loading: 'Loading...',
    name: 'Name',
    noMoreUsers: 'No more users',
    role: 'Role',
    status: 'Status'
};

export default translations;
